module.exports = __webpack_public_path__ + "media/toolkits/HVAC-mobile-ecosystem-a84296a2.png";